// extracted by mini-css-extract-plugin
export default {"container":"jompg","img":"OBzQq","logo":"DOKPv","illustrationFiche":"ahMPg"};